import { Alert } from '@vtex/shoreline'

import { statusType } from '../../statusType'

import * as S from './styles'

interface Props {
  status: string
}

export const Alerts = ({ status }: Props) => {
  return (
    <S.Container>
      <Alert
        variant={statusType[status]?.color}
        style={{ alignItems: 'center' }}
      >
        {statusType[status]?.text}
      </Alert>
    </S.Container>
  )
}
